import { render } from "./index.vue?vue&type=template&id=11635724&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=11635724&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=11635724&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11635724"]])

export default __exports__